const handleClick = (checks, notificationElement) => {
    let blnAtLeastOneChecked = false;

    if (checks?.length > 0) {
        //-- If one check is checked from all checks blnAtLeastOneChecked returns true
        blnAtLeastOneChecked = Array.from(checks).some(check => check.checked);
        if (!blnAtLeastOneChecked) {
            initNotificationAnimation(true, notificationElement, checks);
        }
    }
};

const handleChange = (currentCheck, notificationElement, checks) => {
    !currentCheck.checked ? initNotificationAnimation(true, notificationElement, checks) : initNotificationAnimation(false, notificationElement, checks);
};

const initErrorStyling = (element, showError) => {
    if (showError) {
        if (!element.classList.contains("active-error")) {
            element.classList.add("active-error");
        } else {
            //-- Already active notification => add second class
            element.classList.add("still-active-error");
            //-- Remove the second class after the animation is finished
            setTimeout(() => element.classList.remove("still-active-error"), 500);
        }
    } else {
        element.classList.remove("active-error");
    }
};

const initNotificationAnimation = (blnShow, notificationElement, checks) => {
    initErrorStyling(notificationElement, blnShow);
    if (checks?.length > 0) {
        const hasTermsCheck = check => check.hasAttribute("id") && check.getAttribute("id") === "chkTerms";
        checks.forEach(check => initErrorStyling(hasTermsCheck(check) ? check.parentElement.parentElement : check, blnShow));
    }
};

export const initNotification = (checks) => {
    const proceedWrappers = document.querySelectorAll(".submit-wrapper");
    const notificationElement = document.querySelector("[data-id=\"notificationSelectRequired\"]");

    if (checks?.length > 0) {
        checks.forEach(check => {
            check.addEventListener("change", (e) => handleChange(e.currentTarget, notificationElement, checks));
        });
    }

    if (proceedWrappers?.length > 0) {
        proceedWrappers.forEach(wrapper => {
            wrapper.addEventListener("click", (e) => {
                const submitButton = wrapper.querySelector("input[type=\"submit\"]");
                if (submitButton && submitButton.hasAttribute("disabled")) {
                    handleClick(checks, notificationElement);
                }
            });
        });
    }
};